/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AllegatoDtoFromJSON, AllegatoDtoToJSON, } from './AllegatoDto';
import { DatiAggiuntiviDtoFromJSON, DatiAggiuntiviDtoToJSON, } from './DatiAggiuntiviDto';
import { DatiAziendaFromJSON, DatiAziendaToJSON, } from './DatiAzienda';
import { DatiBilancioFromJSON, DatiBilancioToJSON, } from './DatiBilancio';
import { DettaglioAziendaFromJSON, DettaglioAziendaToJSON, } from './DettaglioAzienda';
import { IndirizziAziendaFromJSON, IndirizziAziendaToJSON, } from './IndirizziAzienda';
import { InfoAziendaFromJSON, InfoAziendaToJSON, } from './InfoAzienda';
import { SedeDtoFromJSON, SedeDtoToJSON, } from './SedeDto';
/**
 * Check if a given object implements the ClienteDto interface.
 */
export function instanceOfClienteDto(value) {
    let isInstance = true;
    return isInstance;
}
export function ClienteDtoFromJSON(json) {
    return ClienteDtoFromJSONTyped(json, false);
}
export function ClienteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'idCliente': !exists(json, 'idCliente') ? undefined : json['idCliente'],
        'idPratica': !exists(json, 'idPratica') ? undefined : json['idPratica'],
        'idSoggetto': !exists(json, 'idSoggetto') ? undefined : json['idSoggetto'],
        'infoAzienda': !exists(json, 'infoAzienda') ? undefined : InfoAziendaFromJSON(json['infoAzienda']),
        'datiAzienda': !exists(json, 'datiAzienda') ? undefined : DatiAziendaFromJSON(json['datiAzienda']),
        'indirizziAzienda': !exists(json, 'indirizziAzienda') ? undefined : IndirizziAziendaFromJSON(json['indirizziAzienda']),
        'datiBilancio': !exists(json, 'datiBilancio') ? undefined : DatiBilancioFromJSON(json['datiBilancio']),
        'dettaglioAzienda': !exists(json, 'dettaglioAzienda') ? undefined : DettaglioAziendaFromJSON(json['dettaglioAzienda']),
        'datiAggiuntivi': !exists(json, 'datiAggiuntivi') ? undefined : DatiAggiuntiviDtoFromJSON(json['datiAggiuntivi']),
        'elencoSedi': !exists(json, 'elencoSedi') ? undefined : (json['elencoSedi'].map(SedeDtoFromJSON)),
        'elencoAllegati': !exists(json, 'elencoAllegati') ? undefined : (json['elencoAllegati'].map(AllegatoDtoFromJSON)),
    };
}
export function ClienteDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'idCliente': value.idCliente,
        'idPratica': value.idPratica,
        'idSoggetto': value.idSoggetto,
        'infoAzienda': InfoAziendaToJSON(value.infoAzienda),
        'datiAzienda': DatiAziendaToJSON(value.datiAzienda),
        'indirizziAzienda': IndirizziAziendaToJSON(value.indirizziAzienda),
        'datiBilancio': DatiBilancioToJSON(value.datiBilancio),
        'dettaglioAzienda': DettaglioAziendaToJSON(value.dettaglioAzienda),
        'datiAggiuntivi': DatiAggiuntiviDtoToJSON(value.datiAggiuntivi),
        'elencoSedi': value.elencoSedi === undefined ? undefined : (value.elencoSedi.map(SedeDtoToJSON)),
        'elencoAllegati': value.elencoAllegati === undefined ? undefined : (value.elencoAllegati.map(AllegatoDtoToJSON)),
    };
}
